import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type PathShowType = 1 | 2 | 3 | 4 | 5 | 6;

interface ScreenSize {
  height: number;
  width: number;
}

interface IState {
  visible: boolean;
  pathShowType: PathShowType[];
  deselectedPathes: number[];
  starDashboardVisible: boolean;
  screenSize: ScreenSize;
  fullScreen: boolean;
}

const initialState: IState = {
  visible: false,
  pathShowType: [3],
  deselectedPathes: [],
  starDashboardVisible: false,
  screenSize: { height: 380, width: 60 },
  fullScreen: false,
};

export const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    changePathShowType: (state, action: PayloadAction<PathShowType[]>) => {
      return { ...state, pathShowType: action.payload };
    },
    deselectPath: (state, action: PayloadAction<any[]>) => {
      return { ...state, deselectedPathes: action.payload };
    },
    starDashboardVisibility: (state, action: PayloadAction<boolean>) => {
      return { ...state, starDashboardVisible: action.payload };
    },
    toggleFullScreen: (state) => {
      return { ...state, fullScreen: !state.fullScreen };
    },
  },
});

export const { toggleVisibility, makeInvisible, changePathShowType, deselectPath, starDashboardVisibility, toggleFullScreen } =
  servicesSlice.actions;

export default servicesSlice.reducer;
